import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcEquipmentTypeInputComponent } from './fc-equipment-type-input.component';


@NgModule({
  declarations: [
    FcEquipmentTypeInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcEquipmentTypeInputComponent
  ]
})
export class FcEquipmentTypeInputModule {}
